import { Controller } from '@hotwired/stimulus';

const TILE_SELECTOR = '.c-tile';

export default class extends Controller {
  #disconnected = false;

  async connect() {
    this.#disconnected = false;

    const [PhotoSwipeLightbox] = await Promise.all([
      import('photoswipe/lightbox').then((module) => module.default),
      import('photoswipe/dist/photoswipe.css'),
    ]);

    if (this.#disconnected) return;

    this.lightbox = new PhotoSwipeLightbox({
      gallery: this.element,
      children: `${TILE_SELECTOR} a[data-zoom]`,
      thumbSelector: 'a[data-zoom]',
      pswpModule: () => import('photoswipe'),
    });

    this.lightbox.addFilter('placeholderSrc', (placeholderSrc, content) => {
      return content.data.element.closest(TILE_SELECTOR).querySelector('img').src;
    });

    this.lightbox.addFilter('thumbEl', (thumbEl) => {
      return thumbEl.closest(TILE_SELECTOR).querySelector('img');
    });

    this.lightbox.init();
  }

  disconnect() {
    this.#disconnected = true;

    this.lightbox?.destroy();
  }
}
